<template>
  <div id="pageRoot">
    <img id="textbox" src="/pages/img/sordocas/svgCas12bg.svg" />

    <span class="normalTheme pageInstruction" style="left: 82px; top: 72px">
      <p>Completa los globos con la opción correcta.</p>
    </span>
    <p id="tag01" class="textBase basicItem01 tagDefault">
      ¡No permitiré que las quemen!
    </p>
    <p id="tag02" class="textBase basicItem01 tagDefault">
      ¡No permitiré que las maten!
    </p>
    <p id="tag03" class="textBase basicItem01 tagDefault">
      ¡No permitiré que las lastimen!
    </p>
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
      id="inputField01"
    />

    <p id="text01" class="textBase pageElement">¡Dejen en paz a las abejas!</p>

    <img
      id="serafin"
      class="pageElement hover-animation-a"
      src="/pages/img/sordocas/svgCasSerafin.svg"
    />
    <img
      id="bees"
      class="pageElement basicItem01"
      src="/pages/img/sordocas/svgCasBees.svg"
    />
  </div>
</template>
<style scoped>
#textbox {
  position: absolute;
  left: 103px;
  top: 440px;
}
#tag01 {
  position: absolute;
  width: 550px;
  text-align: center;
  left: 103px;
  top: 140px;
}
#tag02 {
  position: absolute;
  width: 550px;
  text-align: center;
  left: 103px;
  top: 230px;
}
#tag03 {
  position: absolute;
  width: 550px;
  text-align: center;
  left: 103px;
  top: 320px;
}
#text01 {
  position: absolute;
  left: 164px;
  top: 460px;
  font-size: 30px;
}
#inputField01 {
  position: absolute;
  width: 505px;
  height: 35px;
  left: 319px;
  top: 514px;
  z-index: 2;
}

#serafin {
  position: absolute;
  left: 120px;
  top: 490px;
}
#bees {
  position: absolute;
  left: 600px;
  top: 573px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["cas/Video 19.mp4", "cas/Video 20.mp4", "cas/Video 21a.mp4", "cas/Video 24.mp4",],
    }
  }
}
</script>